
import Data from "../../card/propieties.json";


import "./nav.css";
export function Nav(){
  return (
    <>
      <nav className="container-nav" lang="es">
        <section className="container-section_row">
          {Data.map( (e,index) =>(
            <div key={index}><li className="item-nav_column">{ e.item }</li></div>
          ) )}
        </section>
      </nav>
    </>
  );
}
